const CustomAppHeadContent = () => {
  return <></>
}

export default CustomAppHeadContent
